export default "__VITE_ASSET__BoQ12FKL__"